import React from "react";

import { FormLabel, renderMarkdown } from "@impero-com/ui";
import { Typography } from "antd";

import * as theme from "./TaskWrapper.css";
import { TasksField } from "./types";

const { Text } = Typography;

interface TaskWrapperProps {
    children: React.ReactNode;
    field: TasksField;
}
export function TaskWrapper({ children, field }: TaskWrapperProps) {
    return (
        <div key={field.id} className={theme.fieldContainer}>
            <div className={theme.fieldLabels}>
                <FormLabel>{field.title}</FormLabel>
                <Text>{renderMarkdown(field.instructions)}</Text>
            </div>
            {children}
        </div>
    );
}
